import { useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { DataKeys } from "../../types";
import { HealthLifecycleHorizontalSelector } from "./HealthLifecycleHorizontalSelector";
import { HealthLifecyclePanel } from "./HealthLifecyclePanel";
import { getLocalized, HealthLang } from "./healthTypes";
import { healthLifecycleMobilePanelWrap } from "./healthVisualStyles";

interface HealthLifecycleMobileFlowProps {
    stages: DataKeys[];
    lang: HealthLang;
}

/** Mobile / tablet below lg — horizontal bar + full-width panel (tap only) */
export function HealthLifecycleMobileFlow({ stages, lang }: HealthLifecycleMobileFlowProps) {
    const [activeIndex, setActiveIndex] = useState(0);
    const [transitionDirection, setTransitionDirection] = useState(1);
    const prevIndexRef = useRef(0);

    const selectStage = (index: number) => {
        setTransitionDirection(index >= prevIndexRef.current ? 1 : -1);
        prevIndexRef.current = index;
        setActiveIndex(index);
    };

    const activeStage = stages[activeIndex];

    return (
        <div className="flex w-full min-w-0 flex-col gap-5 bg-white text-left [text-align:left]">
            <HealthLifecycleHorizontalSelector
                stages={stages}
                activeIndex={activeIndex}
                onSelect={selectStage}
                lang={lang}
            />

            <div className={healthLifecycleMobilePanelWrap}>
                <AnimatePresence mode="wait">
                    {activeStage && (
                        <HealthLifecyclePanel
                            key={activeStage.id ?? activeIndex}
                            stage={activeStage}
                            lang={lang}
                            transitionDirection={transitionDirection}
                            compactHeader
                            stageLabel={getLocalized(activeStage?.label, lang)}
                            className="w-full text-left"
                        />
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
}
